module.exports = __webpack_public_path__ + "img/thinkin-logo--avatar.4f66f5da.svg";